/**
 * @module cercaliagl/view/VDropDownMultiple
 */

import $ from 'jquery';
import BaseView from './BaseView';

/**
 * @typedef {Object} Item
 * @property {string} id
 * @property {string} value
 * @property {string} iconName
 * @property {string[]} paths
 * @property {function() : void} enableOption
 * @property {function() : void} disableOption
 */

/**
 * @enum {string}
 */
export const EventType = {
  SELECTED: 'select',
  DESELECTED: 'deselect',
};

/**
 * @classdesc
 *
 */
class VDropDownMultiple extends BaseView {
  /**
   * @constructor
   */
  constructor() {
    const jqElement = $('<div class="v-drop-down-multiple mdc-elevation--z4"><ul class="mdc-list collection"/></div>');

    super(jqElement);

    /**
     * @private
     * @type {Object.<string, JQuery>}
     */
    this.items_ = {};

    /**
     * @private
     * @type {number}
     */
    this.elementsSelected_ = 0;
  }

  /**
   * @param {Item} item Item
   */
  add(item) {
    this.items_[item.id] = $(`
      <li href="#!" data-id="${item.id}" class="mdc-list-item collection-item">
        <span class="mdc-list-item__text">${item.value}</span>
        ${item.iconName ? `<span class="${item.iconName}"></span>` : ''}
      </li>`)
      .on('click', () => {
        const elementCurrentlyEnabled = this.items_[item.id].hasClass('mdc-list-item--activated');
        if (!elementCurrentlyEnabled) {
          this.selectItem(item.id);
          this.eventEmitter_.emit(EventType.SELECTED, item);
        } else {
          this.deselectItem(item.id);
          this.eventEmitter_.emit(EventType.DESELECTED, item);
        }
      })
      .appendTo(this.jqElement_.find('ul'));

    if (item.paths) {
      item.paths.forEach((path) => this.jqElement_.find(`.${item.iconName}`).append(`<span class="${path}"/>`));
    }
  }

  /**
   * @param {string} id Id
   * Selects an item
   * @api
   */
  selectItem(id) {
    this.jqElement_.find(`li[data-id=${id}]`).addClass('mdc-list-item--activated');
    this.elementsSelected_ += 1;
  }

  /**
   * @param {string} id Id
   * Deselects an item
   * @api
   */
  deselectItem(id) {
    this.jqElement_.find(`li[data-id=${id}]`).removeClass('mdc-list-item--activated');
    this.elementsSelected_ -= 1;
  }

  /**
   * @param {string} id Id
   * Removes an item
   * @api
   */
  remove(id) {
    this.jqElement_.remove(this.items_[id]);
    delete this.items_[id];
  }

  /**
   * @return {number} Number of elements selected
   * @api
   */
  getNumberOfElementsSelected() {
    return this.elementsSelected_;
  }
}

export default VDropDownMultiple;
